import React from 'react';
import NavItem from "../../../core/layout/nav/NavItem";
import {IconSVG} from "../icon/IconSVG";

const UserDropdown = ({
                          user,
                          subData,
                          listDropdown,
                          clickDropItemHandler,
                          showIconProfile,
                          subListDrop,
                          clickSubVoiceHandler,
                      }: {
    user: any,
    subData: any,
    listDropdown: any[],
    subListDrop: any[],
    clickDropItemHandler: (name: string) => void
    clickSubVoiceHandler: (name: string) => void
    showIconProfile?: boolean
}) => {

    const fullName = `${user.name} ${user.surname}`;
    const capsName = `${user.name[0]}${user.surname[0]}`;

    return (
        <ul className="navbar-nav me-auto mb-2 mb-lg-0 gap-3 align-items-center">
            <li className="nav-item dropdown d-flex flex-column align-items-end justify-content-end">
                <a className={'nav-link dropdown-toggle p-0'} href="#"
                   role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <span className={'w-100'}>{fullName}</span>
                </a>
                {listDropdown && listDropdown.length > 0 &&
                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                        {listDropdown?.map((item: any, k: number) => (
                            <NavItem item={item} key={k} clickVoiceHandler={clickDropItemHandler}/>
                        ))
                        }
                    </ul>
                }

                {subData &&
                    <ul style={{'listStyle': 'none'}}>
                        <li className="nav-item dropdown">
                            <a className={'nav-link dropdown-toggle p-0'} href="#"
                               role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <small className={'w-100 text-decoration-underline'}>{subData?.name}</small>
                            </a>
                            {subListDrop && subListDrop.length > 0 &&
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                                    {subListDrop?.map((item: any, k: number) => (
                                        <NavItem item={item} key={k} clickVoiceHandler={clickSubVoiceHandler}/>
                                    ))}
                                </ul>
                            }
                        </li>
                    </ul>
                }

            </li>
            <li>
                <strong
                    className={'bg-yellow-200 d-flex align-items-center justify-content-center rounded-5 p-3 text-nowrap'}
                    style={{width: '36px', height: '36px'}}>
                    {showIconProfile
                        ? <IconSVG icon={'./assets/icons/user.svg'} size={'20px'}/>
                        : capsName
                    }
                </strong>
            </li>
        </ul>
    );
};

export default UserDropdown;
